import { createApi } from '@reduxjs/toolkit/query/react';
import { BaseQueryWithReAuth } from '../utils';
import { userAccessPanelAPIEndpoints } from './endpoints';

export const userAccessPanelQuery = BaseQueryWithReAuth({
  baseUrl: `${import.meta.env.VITE_AUTH_BASE_URL}`,
  credentials: 'same-origin',
  setHeaders: (headers) => {
    headers.set(
      'Authorization',
      `Bearer ${localStorage.getItem('accessToken') || ''}`
    );
    return headers;
  }
});

const userAccessPanelAPI = createApi({
  reducerPath: 'userAccessPanelAPI',
  baseQuery: userAccessPanelQuery,
  endpoints: (builder) => ({
    ...userAccessPanelAPIEndpoints(builder)
  })
});

export const {
  usePrefetch,
  useGetUsersQuery,
  useGetModulesQuery,
  useGetUserInfoQuery,
  useGetRolesQuery,
  useUpdateRoleMutation,
  useUpdateUserMutation,
  useLazyResendUserInvitationQuery,
  useCreateNewUserMutation,
  useGetPermissionsQuery,
  useCreatePermissionMutation,
  useDeletePermissionMutation,
  useCreateRoleMutation,
  useUpdatePermissionMutation,
  useUpdateRoleDataMutation,
  useDeleteRoleMutation,
  useChangePasswordMutation
} = userAccessPanelAPI;

export default userAccessPanelAPI;
